/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';

import { useRoutesContext } from 'common/context/routes';
import { useActiveStationsContext } from '../context/activeStations';
import { IStation } from 'dataSources/Typicode/stations';

// TODO maybe need remove
const useUpdateActiveStationsByActiveRoute = () => {
  const { activeRoute, routesStations } = useRoutesContext();
  const { setActiveStations } = useActiveStationsContext();

  const handleUpdateActiveRouteStations = (stations: IStation[]) => {
    setActiveStations(stations, true);
  };

  // useEffect(() => {
  //   if (activeRoute) {
  //     handleUpdateActiveRouteStations(
  //       routesStations[(activeRoute || { id: -1 }).id] || [],
  //     );
  //   }
  // }, [activeRoute]);
};

export default useUpdateActiveStationsByActiveRoute;
